import { collection, addDoc, serverTimestamp, runTransaction, doc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../../config/firebase';
import { UserOrder } from '../../types/user';

export const createOrder = async (
  userId: string,
  userEmail: string,
  characterId: string,
  videoFile: File
): Promise<string> => {
  try {
    // Start a transaction to check credits and create order
    return await runTransaction(db, async (transaction) => {
      // Check user's plan and credits
      const userRef = doc(db, 'users', userId);
      const userDoc = await transaction.get(userRef);
      
      if (!userDoc.exists()) {
        throw new Error('User not found');
      }

      const userData = userDoc.data();
      if (!userData.plan || userData.plan.videosRemaining <= 0) {
        throw new Error('No video credits remaining');
      }

      // Upload the original video
      const videoRef = ref(storage, `original-videos/${userId}/${videoFile.name}`);
      await uploadBytes(videoRef, videoFile);
      const videoUrl = await getDownloadURL(videoRef);

      // Create the order
      const orderRef = await addDoc(collection(db, 'orders'), {
        userId,
        userEmail,
        characterId,
        videoUrl,
        status: 'pending',
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });

      // Decrease user's remaining videos
      transaction.update(userRef, {
        'plan.videosRemaining': userData.plan.videosRemaining - 1
      });

      return orderRef.id;
    });
  } catch (error: any) {
    console.error('Error creating order:', error);
    throw new Error(error.message || 'Failed to create order');
  }
};

export const getOrderById = async (orderId: string): Promise<UserOrder | null> => {
  try {
    const orderDoc = await db.collection('orders').doc(orderId).get();
    if (!orderDoc.exists) return null;
    return orderDoc.data() as UserOrder;
  } catch (error) {
    console.error('Error getting order:', error);
    throw new Error('Failed to get order');
  }
};